export const errorMessages = {
  email: "Please enter a valid email address.",
  password: "Password must be at least 6 characters long.",
};
